import { render, staticRenderFns } from "./AddonsListItem.vue?vue&type=template&id=1eed2ba9&scoped=true"
import script from "./AddonsListItem.vue?vue&type=script&lang=js"
export * from "./AddonsListItem.vue?vue&type=script&lang=js"
import style0 from "./AddonsListItem.vue?vue&type=style&index=0&id=1eed2ba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eed2ba9",
  null
  
)

export default component.exports